import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DiscountCouponService from "./Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import PropTypes from 'prop-types';
import { Col, CardBody, Card } from "reactstrap";
import PermissionAccess from '../../PermissionAccess/Access.js';

const EditDiscountCouponModal = ({ showModalEditDiscountCoupon, handleToggleModalEditDiscountCoupon, id, onSuccess }) => {
  //console.log('ID :'+id);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  const [data, setData] = useState({
    name: '',
    status: '',
    quantity_id: '',
  });

  const [errors, setErrors] = useState({
    name: '',
    status: '',
    quantity_id: '',
  });

  //get data
  useEffect(() => {
    const fetchData = async () => {
        setLoading(true);
        DiscountCouponService.GetSingleDose(authData.sessionID,id).then((response) => {
            setLoading(false);
            if (response.data.message === "Unauthorized") {
                AuthService.logout();
                navigate("/login");
                window.location.reload();
            } else {
                if (response.data.status == true) {
                    setData({
                        name: response.data.data.data.name,
                        status: response.data.data.data.status,
                        quantity_id: response.data.data.data.quantity_id,
                      });
                    
                  }
                  else {
                    Alerts.swalErrorAlert(t("Something went wrong, Please try again."));
                  }
            }
        }, (error) => {
            setLoading(false);
            const errContent = (error.response && error.response.data) || error.message || error.toString();
            if (errContent) {
                //Alerts.swalErrorAlert(errContent);
            } else {
                Alerts.swalErrorAlert(t("Server Error, Please try again later."));
            }
        });
    };
    fetchData();
  }, [id]);

  

  const handleChange = (e) => {
    const { name,quantity_id, value } = e.target;
    let error = '';
  
    if (name === 'name' && !value) {
      error = 'Dose is required';
    }  else if (name === 'status' && !value) {
      error = 'Status is required';
    } else if (name === 'quantity_id' && !value) {
        error = 'Measurement is required';
      }
  
    setErrors({ ...errors, [name]: error });
    setData({ ...data, [name]: value });
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    if (!data.name) { validationErrors.name = 'Dose is required'; }
    if (!data.status) { validationErrors.status = 'Status is required'; }
    if (!data.quantity_id) { validationErrors.quantity_id = 'Measurement is required'; }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      DiscountCouponService.EditDose(authData.sessionID,data,id).then((response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          if (response.data.status === true) {
            handleToggleModalEditDiscountCoupon();
            onSuccess();
            Alerts.swalSuccessAlert(t("Dose updated successfully."));
            validationErrors.name = '';
          } else {
            console.log('')
            validationErrors.name = response.data.errors[0].message || 'An error occurred';
            setErrors(validationErrors);
          }
        }
      }, (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
    }
  };

  

  const handleClose = () => {
    setErrors({
      name: '',
      status: '',
      quantity_id: '',
    });
    handleToggleModalEditDiscountCoupon();
  };

  return (
    <div className={showModalEditDiscountCoupon ? "modal d-block mt-4" : "modal"} style={{ display: showModalEditDiscountCoupon ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} tabIndex="-1" role="dialog">
      <form onSubmit={handleSubmit}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{t("Edit Dose")}</h5>
            </div>
            <div className="modal-body">
            <Col md="12">
                <Card className="main-card mb-3">
                     <CardBody>
              <LoadingOverlay
                tag="div"
                active={loading}
                styles={{ overlay: (base) => ({ ...base }) }}
                spinner={<DNALoader />}
              >
                <input type="hidden" className="form-control" name="business_id" />

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="coupon-code" className="col-form-label">{t("Dose")}:</label>
                      <input type="text" className="form-control" placeholder="Enter Dose" 
                      name="name"
                      onChange={handleChange}
                      value={data.name}
                      />
                      {errors.name && <strong className="error text-danger">{errors.name}</strong>}
                    </div>
                  </div>
                  
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                        <label htmlFor="status-select" className="col-form-label">{t("Measurement")}:</label>
                        <select className="form-control" 
                        name="quantity_id"
                        onChange={handleChange}
                        value={data.quantity_id}
                        >
                            <option value="">{t("Select Measurement")}</option>
                            <option value="675e9092c38e64e794e35ef8">{t("Box")}</option>
                            <option value="675e90d0c38e64e794e35ef9">{t("Blister Pack")}</option>
                        </select>
                        {errors.quantity_id && <strong className="error text-danger">{errors.quantity_id}</strong>}
                        </div>
                    </div>
                </div>

                

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="status-select" className="col-form-label">{t("Status")}:</label>
                      <select className="form-control" 
                      name="status"
                      onChange={handleChange}
                      value={data.status}
                      >
                        <option value="">{t("Select Status")}</option>
                        <option value="Active">{t("Active")}</option>
                        <option value="InActive">{t("InActive")}</option>
                      </select>
                      {errors.status && <strong className="error text-danger">{errors.status}</strong>}
                    </div>
                  </div>
                  
                  <div className="text-center mt-4">
                  <button type="button" className="btn btn-outline-light btn-hover-shine me-3" onClick={handleClose}>{t("Close")}</button>
                  <button type="submit" className="btn btn-custom-color">{t("Save")}</button>
                </div>
                </div>
                                            </LoadingOverlay>
                                        </CardBody>
                                    </Card>
                                </Col>
            </div>
            
          </div>
        </div>
      </form>
    </div>
  );
};


EditDiscountCouponModal.propTypes = {
    showModalEditDiscountCoupon: PropTypes.bool.isRequired,
    handleToggleModalEditDiscountCoupon: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired, // Ensure id is required and of type string or number
  };

export default EditDiscountCouponModal;
